const NavLanding = () => {
  return (
    <div className="menuItems">
      <ul>
        <li>
          <p>Features</p>
        </li>
        <li>
          <p>Articles</p>
        </li>
        <li>
          <p>Pricing</p>
        </li>
      </ul>
    </div>
  )
}

export default NavLanding